import { CHAT_MODULE_LOGO } from '@interacta-shared/util-common';

export const CHAT_LOGO = CHAT_MODULE_LOGO.light;
export const CHAT_LOGO_DARK = CHAT_MODULE_LOGO.dark;
